import React from "react";
import MainBannerBG from "../../assets/leadership-bg.png";
import LCLogo from "../../assets/laguna-creek-logo.png";
import { Link } from "react-router-dom";

function ThankYouPage() {
  return (
    <>
      <section
        className="py-12 md:py-24 bg-cover bg-center"
        style={{
          backgroundImage: `url(${MainBannerBG})`,
        }}
      >
        <div className="w-full max-w-[1570px] px-4 mx-auto">
          <div className="flex flex-wrap -mx-4">
            <div className="w-full max-w-full px-4 text-center">
              <img
                src={LCLogo}
                alt="OurStory"
                className="max-w-[200px] mx-auto mb-8"
                height="548"
                width="547"
              />
              <h1 className="text-[30px] md:text-[40px] lg:text-[52px] font-bold leading-tight text-[#333333] mb-4">
                THANK YOU!
              </h1>
              <p className="text-lg font-light leading-7 text-[#333333] mb-8">
                Your request has been submitted successfully. One of our experts
                will get in touch with you shortly.
              </p>
              <Link
                to="/"
                className="inline-block text-lg font-bold leading-6 text-white bg-[#5fa3b2] py-4 px-9 rounded-xl transition-all ease-in-out duration-500 hover:bg-[#FAA42A]"
              >
                Back To Home
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ThankYouPage;
